import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=56387c22&scoped=true"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=56387c22&prod&lang=scss&scoped=true"
import style1 from "./userInfo.vue?vue&type=style&index=1&id=56387c22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56387c22",
  null
  
)

export default component.exports